import React from 'react';
import { FDAlert, FDStack } from '@facet-wealth/design';
import {
  BodyTextLarge, BodyTextSmall, LabelTextMedium,
} from 'Packages/FacetDesign/Components';
import PropTypes from 'prop-types';

export const BalanceDisplay = ({
  value, label,
  helperText,
  desiredEndBalance, remainingEndBalance,
}) => {
  const isError = (remainingEndBalance < desiredEndBalance);

  return (
    <>
      {!isError && <>
        <FDStack direction={'column'}>
          <LabelTextMedium value={label} />
          <BodyTextLarge value={value} />
          <BodyTextSmall value={helperText} color={'textDisabled'} />
        </FDStack>
      </>}
      {isError && <>
        <FDAlert
          title={label}
          description={value}
          details={[
            helperText,
          ]}
          status={'warning'}
        />
      </>}
    </>
  );
};

BalanceDisplay.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string.isRequired,
  desiredEndBalance: PropTypes.number.isRequired,
  remainingEndBalance: PropTypes.number.isRequired,
};

BalanceDisplay.defaultProps = {
  value: undefined,
  label: undefined,
};
